// Pure helpers for the marketing kit renderer (kitRender.ts), split out so
// they test in plain node — kitRender imports qr-code-styling, which needs a
// DOM.

export type KitFormat = 'post' | 'story' | 'poster' | 'quote'

/** Ask Cloudinary for a right-sized JPEG instead of the original upload. */
export function sizedImageUrl(url: string, width = 1400): string {
  const m = url.match(/^(https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(.*)$/)
  if (!m) return url
  // Leave an existing transformation alone.
  if (/^[a-z]_[^/]*\//.test(m[2])) return url
  return `${m[1]}c_limit,w_${width},q_auto,f_jpg/${m[2]}`
}

/**
 * Wrap text into lines that fit maxWidth. Pure apart from the measure
 * callback, so it is unit-tested with a fake measure.
 */
export function wrapLines(text: string, maxWidth: number, measure: (s: string) => number): string[] {
  const words = text.trim().split(/\s+/).filter(Boolean)
  const lines: string[] = []
  let line = ''
  for (const w of words) {
    const next = line ? `${line} ${w}` : w
    if (measure(next) <= maxWidth || !line) {
      line = next
    } else {
      lines.push(line)
      line = w
    }
  }
  if (line) lines.push(line)
  return lines
}

/** "halloween-feed-post.png" */
export function kitFileName(title: string, format: KitFormat, index?: number): string {
  const slug = title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40) || 'kit'
  const fmt = { post: 'feed-post', story: 'story', poster: 'poster-a4', quote: 'quote' }[format]
  return `${slug}-${fmt}${index != null ? `-${index + 1}` : ''}.png`
}
